<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    @if (patient().isPediatric()) {
      <p>
        WNL: Regular respiratory rate and quality. Lung sounds clear to auscultation. No cough noted.
        Pulse oximetry greater than 92% on room air. Symmetrical chest, no respiratory distress.
        No retractions present.
      </p>
    }
    @else {
      <p>
        WNL: Regular respiratory rate and quality. Lung sounds clear to auscultation. No cough noted.
        Pulse oximetry greater than 92% on room air. Symmetrical chest, no respiratory distress.
      </p>
    }

    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()">
  <h2>Respiratory Pattern</h2>

  <assessment-row title="Rhythm">
    <emr-checkbox [control]="formGroup().controls.irregularRhythm" label="Irregular"
      [wnlControl]="'irregularRhythm'" [wnlDefault]="false" />
  </assessment-row>

  @if (patient().isPediatric()) {
    <assessment-row title="Retractions Present">
      <emr-checkbox [control]="formGroup().controls.retractionsPresent" label="Yes"
        [wnlControl]="'retractionsPresent'" [wnlDefault]="false" />
    </assessment-row>
  }

  <assessment-row title="Quality">
    <emr-input type="select" [control]="formGroup().controls.quality" [options]="qualityOptions"
      [wnlControl]="'quality'" [wnlDefault]="'WNL'" />
    @if (isOtherQuality) {
    <emr-input type="text" label="Comments" [control]="formGroup().controls.qualityOther" />
    }
  </assessment-row>

  <h2>Lung Sounds</h2>
  <div>
    <div class="lung-sound">
      <emr-input type="select" label="RUL" [control]="formGroup().controls.lungSoundsRul"
        [options]="lungSoundOptions" [wnlControl]="'rul'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      @if (isOtherRUL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsRulOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" label="RML" [control]="formGroup().controls.lungSoundsRml"
        [options]="lungSoundOptions" [wnlControl]="'rml'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      @if (isOtherRML) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsRmlOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" label="RLL" [control]="formGroup().controls.lungSoundsRll"
        [options]="lungSoundOptions" [wnlControl]="'rll'" [wnlDefault]="'WNL'" [bottomSpace]=" true" />
      @if (isOtherRLL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsRllOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" label="LUL" [control]="formGroup().controls.lungSoundsLul"
        [options]="lungSoundOptions" [wnlControl]="'lul'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      @if (isOtherLUL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsLulOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" label="LLL" [control]="formGroup().controls.lungSoundsLll"
        [options]="lungSoundOptions" [wnlControl]="'lll'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      @if (isOtherLLL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsLllOther" />
      }
    </div>
  </div>

  <h2>Breathing</h2>
  <assessment-row title="Increased Work of Breathing">
    <emr-input type="text" [control]="formGroup().controls.increasedWorkOfBreathing"
      [wnlControl]="'increasedWorkOfBreathing'" [wnlDefault]="''" />
  </assessment-row>

  <h2>Cough</h2>
  <assessment-row title="Cough present?">
    <emr-checkbox [control]="formGroup().controls.cough" label="Yes" [wnlControl]="'cough'" [wnlDefault]="false" />
  </assessment-row>
  @if (isCoughPresent) {
  <assessment-row title="Describe cough">
    <emr-input type="select" label="Cough Description" [control]="formGroup().controls.coughDescription"
      [options]="coughDescriptionOptions" />
  </assessment-row>

  @if (isCoughProductive) {
  <assessment-row title="Describe productive cough">
    <emr-checkbox-group [control]="formGroup().controls.productiveDescription"
      [options]="productiveDescriptionOptions" />
  </assessment-row>
  }
  }

  <h2>Trach</h2>
  <assessment-row title="Trach Present">
    <emr-checkbox [control]="formGroup().controls.trachPresent" label="Yes" [wnlControl]="'trachPresent'"
      [wnlDefault]="false"></emr-checkbox>
  </assessment-row>
  @if (isTrachPresent) {
    <assessment-row title="Trach Size">
      <emr-input type="text" [control]="formGroup().controls.trachSize"></emr-input>
    </assessment-row>

    <assessment-row title="Inner Cannula Changed?">
      <emr-checkbox [control]="formGroup().controls.innerCannulaChanged" label="Yes"></emr-checkbox>
    </assessment-row>
    @if (isInnerCannulaChanged) {
      <assessment-row title="Cannula Changed Details">
        <emr-input type="text" [control]="formGroup().controls.innerCannulaChangedDetails"></emr-input>
      </assessment-row>
    }

    <assessment-row title="Trach Ties Changed">
      <emr-checkbox [control]="formGroup().controls.trachTiesChanged" label="Yes"></emr-checkbox>
    </assessment-row>
    @if (isTrachTiesChanged) {
      <assessment-row title="Trach Ties Changed Details">
        <emr-input type="text" [control]="formGroup().controls.trachTiesChangedDetails"></emr-input>
      </assessment-row>
    }

    <assessment-row title="Suction">
      <emr-input type="text" [control]="formGroup().controls.suction"></emr-input>
    </assessment-row>
  }

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" />
  </assessment-row>
</div>
</div>